<template>

    <div class="fixed bottom-0 left-2/4 -translate-x-2/4 z-50 bg-white shadow-2xl text-center p-3 w-full border-t">
        <button
            ref="buyButton"
            class="btn btn-buy btn-lg flex-grow h-12 active add-to-cart disabled:opacity-50 disabled:bg-buy disabled:text-buy-content"
            :disabled="loading || product?.stock < 0 || product?.deliveryTimeCustomFields?.available_for_purchase === 'available_for_purchase_not_orderable' || !setProductConfigured"
            @click="onClickAddToCart(qty, product?.id)"
        >
            <div class="flex gap-2 items-center">

                <template v-if="!setProductConfigured">
                    {{ t('structure.productSet.configurationNoticeButton', {count: selectedProductCount, maxCount: setInformation?.productSet?.count}) }}
                </template>

                <template v-else>
                    {{ t('product.buyBox.setAddToCart') }}
                </template>

                <span v-if="loading" class="loading" />

                <MiscIcon
                    v-else
                    :name="'cart-box-arrow-down'"
                    :size="'lg'"
                />
            </div>
        </button>
    </div>

</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import {useCart, useDrawer, useNuxtApp} from '#imports'
import type { HblProduct } from '@/utils/types'
import {computed, ref} from "vue";
const { $hblBus } = useNuxtApp()

const { t } = useI18n()

const props = defineProps<{
    productData: HblProduct
    setProductConfigured?: boolean
}>()

const product = ref(props.productData)
const qty = ref<number>(1)
const cartStore = useCart()
const { loading: cartLoading, error: cartError } = storeToRefs(cartStore)
const { addToCart } = cartStore
const variantLoading = ref(false)
const loading = computed(() => {
    return cartLoading.value || variantLoading.value
})
const { toggleDrawer } = useDrawer()
const setProductStore = useSetProduct()
const { fetchSet } = setProductStore
const { configuredSet, setInformation } = storeToRefs(setProductStore)

async function onClickAddToCart (qty: number, id: string) {
    await addToCart(qty, id)

    if (!cartError.value) {
        $hblBus.$emit('addToCart', { qty, product: product?.value })
    }

    toggleDrawer('cart', 'right')
}

const selectedProductCount = computed(() => {
    return Object.values(configuredSet.value).reduce(
        (acc, value) => acc + value,
        0,
    );
})
</script>